import { useMemo, useReducer, useRef } from "react";
import { getArrayReducer } from "../Tools/ArrayTools";

interface IUseArrayStateOptions<T> {
    equals?: (a: T, b: T) => boolean;
    initialValue?: Array<T>;
}

type TUseArrayStateReturn<T> = [
    Array<T>,
    {
        add: (...newItem: T[]) => void;
        remove: (...item: T[]) => void;
        reset: (newItems?: T[] | undefined) => void;
    }
];

export default function useArrayState<T>(
    options?: IUseArrayStateOptions<T>
): TUseArrayStateReturn<T> {
    const arrayReducer = useRef(
        getArrayReducer<T>(options?.equals ?? ((a, b) => a === b))
    );

    const [array, dispatch] = useReducer(
        arrayReducer.current,
        options?.initialValue ?? []
    );

    const set = useMemo(
        () =>
            ({
                add: (newItem) => dispatch({ action: "add", newItem }),
                remove: (item) => dispatch({ action: "remove", newItem: item }),
                reset: (newItems) => dispatch(newItems),
            } as TUseArrayStateReturn<T>[1]),
        []
    );

    return [array, set];
}
